import React from 'react';
import Markdown from 'markdown-to-jsx';
import startsWith from 'ramda/es/startsWith';
import { CollectionName } from '@tomis-tech/types';

import { useParent, useSession } from '../context';
import { GA4Event } from '../../tracking/event-types';
import { getLinkClickUserActionMessage } from '../messages';
import { trackGA4Event } from '../../tracking';

const Link = props => {
  const { goToUrl, pageView } = useParent();
  const { conversation } = useSession();

  // const targetUrl = new URL(props.href); // NOTE: props.href isn't currently guaranteed to be a valid url, which could throw an error here
  // const externalLink = targetUrl.hostname !== pageView.page.url.hostname;
  return (
    <a
      {...props}
      // target="_blank"
      onClick={e => {
        // if (externalLink) return;
        e.preventDefault();
        if (startsWith('tel:', props.href)) {
          trackGA4Event(GA4Event.ClickedPhone, { link_url: props.href }, true);
        } else if (startsWith('mailto:', props.href)) {
          trackGA4Event(GA4Event.ClickedEmail, { link_url: props.href }, true);
        } else {
          trackGA4Event(GA4Event.ClickedUrl, { link_url: props.href }, true);
        }
        // Save userAction in Firebase
        const linkClickMessage = getLinkClickUserActionMessage(
          props.href,
          pageView
        );
        conversation.ref
          .collection(CollectionName.Messages)
          .add(linkClickMessage)
          .then(() => {
            // wait until message is stored before redirect
            goToUrl(props.href);
          })
          .catch(error => {
            console.error('Error saving message: ', error);
            goToUrl(props.href);
          });
      }}
      css={(theme: Theme) => ({
        color: theme.colors.link,
        textDecoration: 'none',
        transition: 'color 0.2s',
        '&:hover': {
          color: theme.colors.linkHover,
        },
      })}
    />
  );
};

const UnorderedList = props => <ul {...props} style={{ marginLeft: '15px' }} />;
const OrderedList = props => <ol {...props} style={{ marginLeft: '15px' }} />;

const MessageContent = React.memo(
  ({ children }: { children: React.ReactNode }) => {
    return (
      <Markdown
        options={{ overrides: { a: Link, ul: UnorderedList, ol: OrderedList } }}
      >
        {children}
      </Markdown>
    );
  }
);

export default MessageContent;
